import type { BaseViewClipboard } from '../common/clipboard.js';

export class KanbanViewClipboard implements BaseViewClipboard {
  init() {
    // todo
  }
}
